import React from 'react';
import HomePageStories from '../components/HomeComponents/HomePageStories';
import HomeFlowPostItem from '../components/HomeComponents/HomeFlowPostItem';

const MainFlow = () => {
    return (
        <div className="MainFlow">
            <div className="Flow_Left ">
                <HomePageStories/>
                <HomeFlowPostItem/>
                <div style={{clear:'both'}}></div>
            </div>
            <div className="Flow_Right bg-danger">
                <div className="">
                Recommended Follows
                </div>
            </div>
        </div>
    );
}

export default MainFlow;
